import React from 'react';

import { Description } from '../Description';
import { Header } from '../Header';
import { LoadingBlock } from '../LoadingBlock';

import styles from './StaticCard.module.scss';

export interface IStaticCardProps {
  title: string;
  content?: string;
  icon?: React.ReactNode;
  dataTest?: string;
  maxContentLines?: number;
  isLoading?: boolean;
}

export const StaticCard: React.SFC<IStaticCardProps> = (props) => {
  const title = props.isLoading ? <LoadingBlock /> : props.title;
  const content = props.isLoading ? (
    <LoadingBlock className={styles.loadingContent} />
  ) : (
    props.content && (
      <div className={styles.content}>
        <Description variant="condensed" dataTest="content" maxLines={props.maxContentLines}>
          {props.content}
        </Description>
      </div>
    )
  );

  return (
    <div className={styles.basicCard} role="button" tabIndex={0} data-test={props.dataTest}>
      {!props.isLoading && props.icon && <div className={styles.icon}>{props.icon}</div>}
      <div className={styles.contentWrapper}>
        <Header variant="h4" dataTest="title">
          {title}
        </Header>
        {content}
      </div>
    </div>
  );
};
